import gql from 'graphql-tag';

import dictionaryDokkioLabelFragment from '../fragments/dictionaryDokkioLabelFragment';

export const queryDictionaryDokkioLabels = gql`
  query dictionaryDokkioLabels (
    $industry: String
    $role: String
    $weights: [Int!]
  ) {
    dictionaryDokkioLabels(
      industry: $industry
      role: $role
      weights: $weights
    ) {
      ...dictionaryDokkioLabelFragment
    }
  }
  ${dictionaryDokkioLabelFragment}
`;
export default queryDictionaryDokkioLabels;
